// Strip scheme + any myworkpay.* suffix + trailing slashes; lowercase. Mirror of
// the BE normalization so the resolve call matches.
export function normalizeSubdomain(raw: string): string {
  return raw
    .trim()
    .toLowerCase()
    .replace(/^https?:\/\//, '')
    .replace(/\.myworkpay\.[a-z]+\/?$/, '')
    .replace(/\/+$/, '');
}
